import PlusIcon from "../../../../components/Icons/PlusIcon";
import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./StandardBundle.module.css";
import BundlePreviewWrapper, {
    CustomSwatches,
    OldCustomSwatches,
    SubscriptionSelector,
    Swatches,
    VariantSelector,
    VariantSelectorV2,
} from "../../BundlePreviewWrapper/BundlePreviewWrapper";
import { ProductObj, StandardConfigInterface, VariantsObj } from "../../Types";
import {
    getPriceLabel,
    getFinalPrice,
    updateShowImage,
    AvailableStandardTemplates,
    buildMetafieldFromSwatchOptions,
} from "../../constants";
import { TStoreContext } from "../../../../context/types";
import ProductImageWrapper from "../../BundlePreviewWrapper/ProductImageWrapper";
import useIsMobile from "../../../../hooks/useIsMobile";
import ProductSubscriptionsPreview from "../../BundlePreviewWrapper/ProductSubscriptionsPreview";
import { InspectorEditableBlock } from "../../CommonFields/InspectorEditableBlock";
import { ADITYA_STORE, COOLGEL_STORE, getProductId, MAYUR_TEST_STORE } from "../../../constants";
import { RenderVariantInfo } from "../../BundleBuilder/BundleBuilderBundle/BBProductCard";

const StandardBundle = ({ bundleConfig, targetForm }: { bundleConfig: StandardConfigInterface; targetForm?: any }) => {
    return (
        !!bundleConfig && (
            <StandardPreview
                bundleConfig={bundleConfig}
                standAlone={true}
                targetForm={targetForm}
                appConfigContext={
                    {
                        currency: window.kefi_bundles.localization.currency,
                        money_format: window.kefi_bundles.money_format,
                    } as TStoreContext
                }
            />
        )
    );
};

type Props_StandardPreview = {
    bundleConfig: StandardConfigInterface;
    standAlone?: boolean;
    appConfigContext: TStoreContext;
    targetForm: any;
    inspectorMode?: boolean;
};

const ProductCardShimmer = () => {
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100px",
                fontSize: "20px",
                color: "#999999",
            }}
        >
            Select product(s)
        </div>
    );
};

const ProductCard = ({
    product,
    index,
    bundleConfig,
    appConfigContext,
    standAlone = false,
    setTrackVariant = () => {},
    isMobile,
}: {
    product: ProductObj;
    index: number;
    bundleConfig: StandardConfigInterface;
    appConfigContext: TStoreContext;
    standAlone: boolean;
    setTrackVariant: any;
    isMobile: boolean;
}) => {
    const [disPrice, setDisPrice] = useState(0);
    const [origPrice, setOrigPrice] = useState(0);

    const [selectedVariants, setSelectedVariants] = useState<Array<VariantsObj>>(
        new Array(product.quantity)
            .fill(product.variants.find((vv) => vv.availableForSale == true) || product.variants[0])
            .map((variant) => ({
                ...variant,
                selling_plan: !product.oneTimePurchase
                    ? product.subscriptions && product?.subscriptions.find((sub) => sub.checked === true)?.id
                    : "",
                copyPrice: variant.price,
            })),
    );
    const { currency, money_format } = appConfigContext;
    const [showVariantName, setShowVariantName] = useState("");
    useEffect(() => {
        if (
            product?.variants?.length == 1 &&
            product.variants[0].title?.toLowerCase() != product?.title?.toLowerCase()
        ) {
            setShowVariantName(product.variants[0].title || "");
        } else {
            setShowVariantName("");
        }
    }, [product]);
    console._log("selectedVariants,selectedVariants", selectedVariants);
    useEffect(() => {
        if (product?.variants?.length) {
            let disP = +product.variants[0].price * product?.quantity;
            const origP = +product.variants[0].price * product?.quantity;
            const dis = bundleConfig?.discount_value || 0;
            switch (bundleConfig?.discount_type) {
                case "percentage":
                    disP = disP - disP * (dis / 100);
                    break;
                default:
            }

            setDisPrice(Math.round(disP * 100) / 100);
            setOrigPrice(Math.round(origP * 100) / 100);
            setSelectedVariants(
                new Array(product.quantity)
                    .fill(product.variants.find((vv) => vv.availableForSale == true) || product.variants[0])
                    .map((variant) => ({
                        ...variant,
                        selling_plan: !product.oneTimePurchase
                            ? product.subscriptions && product?.subscriptions.find((sub) => sub.checked === true)?.id
                            : "",
                        copyPrice: variant.price,
                    })),
            );
        } else {
            setDisPrice(0);
            setOrigPrice(0);
        }
    }, [product, bundleConfig?.discount_type, bundleConfig?.discount_value]);

    useEffect(() => {
        // Add productIdx to each selectedVariant
        const updatedSelectedVariants = selectedVariants?.map((variant: any) => ({
            ...variant,
            productIdx: index, // Add the product index
        }));
        product.selectedVariants = updatedSelectedVariants; // Assign updated variants to the product

        // console._log("updatedSelectedVariants", updatedSelectedVariants);

        // Update trackVariant state
        setTrackVariant((prevVariants: any[]) => {
            const updatedVariants = [...prevVariants];
            updatedVariants[index] = updatedSelectedVariants; // Update the specific index with updated variants
            return updatedVariants;
        });

        let totalOriginalPrice = 0;
        let totalDiscountedPrice = 0;

        // Calculate total original price
        updatedSelectedVariants.forEach((variant: any) => {
            const variantPrice = bundleConfig?.apply_discount_on_compare_price
                ? +variant?.compareAtPrice
                : +variant?.price;
            totalOriginalPrice += variantPrice;
        });

        // Apply discount based on bundleConfig after summing the prices
        totalDiscountedPrice = totalOriginalPrice;
        const discountValue = bundleConfig?.discount_value || 0;

        switch (bundleConfig?.discount_type) {
            case "percentage":
                totalDiscountedPrice = totalOriginalPrice - totalOriginalPrice * (discountValue / 100);
                break;
            default:
                break;
        }

        // Set the final calculated prices, rounded to 2 decimal places
        setDisPrice(Math.round(totalDiscountedPrice * 100) / 100);
        setOrigPrice(Math.round(totalOriginalPrice * 100) / 100);
    }, [selectedVariants, product, bundleConfig, index, bundleConfig?.apply_discount_on_compare_price]);

    const handleProductClick = (e: any) => {
        e?.preventDefault();
        if (bundleConfig.disable_product_title_link) {
            return;
        }
        if (standAlone && !window.location.pathname.includes(product.handle)) {
            window.open(`https://${window?.location?.host}/products/${product.handle}`, "_blank");
        } else if (!window.location.pathname.includes(product.handle)) {
            window.open(`https://${shopify?.config?.shop}/products/${product.handle}`, "_blank");
        }
    };

    useEffect(() => {
        if (product.subscriptions && product.subscriptions.length > 0 && !product.oneTimePurchase) {
            product.isSubscribed = true;
        }
    }, [product, product.oneTimePurchase]);

    // console._log("productvariants:", product, selectedVariants);

    const isProductAvailable = useMemo(() => {
        return product.variants.some((vv) => (vv.quantityAvailable && vv.quantityAvailable > 0) || vv.availableForSale);
    }, [product]);

    const divisor = bundleConfig.show_unit_price ? Math.max(selectedVariants.length, 1) : 1;

    const displayPrice = disPrice / divisor;
    const displayComparePrice = origPrice / divisor;

    const showComparePrice = displayComparePrice !== displayPrice;

    const formatPrice = (price: number) => {
        return price <= 0 ? bundleConfig?.free_text || "Free" : getPriceLabel(price, money_format, currency);
    };

    const renderPrice = isProductAvailable ? (
        <div
            style={{
                color: bundleConfig?.bundles_design.highlighted_price_tag_color,
                fontSize: bundleConfig?.bundles_design.highlighted_price_tag_size,
                fontWeight: bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[0],
                fontStyle: bundleConfig?.bundles_design.highlighted_price_tag_style?.split(" ")[1],
                display: "flex",
                flexDirection: isMobile
                    ? bundleConfig.selected_template_standard === AvailableStandardTemplates.HORIZONTAL_BASIC
                        ? "column"
                        : "row"
                    : bundleConfig.selected_template_standard === AvailableStandardTemplates.VERTICAL_BASIC
                      ? "row"
                      : "column",
                justifyContent: "flex-end",
                alignItems:
                    isMobile || bundleConfig.selected_template_standard === AvailableStandardTemplates.HORIZONTAL_BASIC
                        ? "center"
                        : bundleConfig.selected_template_standard === AvailableStandardTemplates.VERTICAL_CLASSIC
                          ? "flex-end"
                          : "baseline",
                gap:
                    isMobile || bundleConfig.selected_template_standard === AvailableStandardTemplates.VERTICAL_BASIC
                        ? "5px"
                        : "0px",
            }}
            className={styles.renderPrice}
        >
            <InspectorEditableBlock bundleType={bundleConfig.bundle_type} settingKey="productPrice">
                <div
                    className={styles.productPrice}
                    style={{
                        width: "max-content",
                        display: "flex",
                        alignItems: "baseline",
                    }}
                >
                    <span>{formatPrice(displayPrice)}</span>

                    {bundleConfig.show_unit_price && bundleConfig.show_unit_price_text && (
                        <span
                            style={{
                                fontSize: bundleConfig.bundles_design.highlighted_price_tag_size - 2,
                            }}
                        >
                            {bundleConfig.show_unit_price_text}
                        </span>
                    )}
                </div>
            </InspectorEditableBlock>

            {showComparePrice && (
                <InspectorEditableBlock bundleType={bundleConfig.bundle_type} settingKey="productCompareAtPrice">
                    <div
                        className={styles.strikePrice}
                        style={{
                            fontSize: bundleConfig?.bundles_design.product_price_size,
                            color: bundleConfig?.bundles_design.product_price_color,
                            fontWeight: bundleConfig?.bundles_design.product_price_style?.split(" ")[0],
                            fontStyle: bundleConfig?.bundles_design.product_price_style?.split(" ")[1],
                            width: "max-content",
                            lineHeight: "normal",
                        }}
                    >
                        {formatPrice(displayComparePrice)}
                    </div>
                </InspectorEditableBlock>
            )}
        </div>
    ) : (
        <span className={styles.outOfStockText}>{bundleConfig?.no_stock_text || "Out of stock"}</span>
    );

    const renderVariantInformation = () => {
        if (
            bundleConfig.bundle_product_level === "variant" ||
            (bundleConfig.bundle_product_level === "product" &&
                // @ts-expect-error hack
                product?.variantsCount?.count > 1 &&
                product.variants.length == 1)
        ) {
            return (
                <div className={styles.variantInfoContainer}>
                    <RenderVariantInfo
                        product={showVariantName ? { ...product, title: showVariantName } : product}
                        style={{
                            color: bundleConfig?.bundles_design?.variant_selector_text_color,
                            fontSize: bundleConfig?.bundles_design?.variant_selector_text_size,
                            fontWeight:
                                bundleConfig?.bundles_design?.variant_selector_text_style?.split(" ")[0] ?? "450",
                            fontStyle:
                                bundleConfig?.bundles_design?.variant_selector_text_style?.split(" ")[1] ?? "normal",
                        }}
                        bundleType={bundleConfig?.bundle_type}
                    />
                </div>
            );
        }
    };

    const renderTitle = (
        <>
            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="productTitle" wrapWithDiv={true}>
                <div
                    style={{
                        fontSize: bundleConfig?.bundles_design.product_name_size,
                        color: bundleConfig?.bundles_design?.product_name_color,
                        fontWeight: bundleConfig?.bundles_design?.product_name_style?.split(" ")[0],
                        fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                    }}
                    onClick={handleProductClick}
                    className={styles.productTitle}
                >
                    {product?.title}
                    {/* {renderVariantTitle()} */}
                </div>
            </InspectorEditableBlock>
        </>
    );

    const renderQuantity = (
        <>
            {(!isMobile || !updateShowImage(bundleConfig?.bundles_design?.product_img_show, isMobile)) && (
                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="productQuantity">
                    <div
                        className={styles.qtyValue}
                        style={{
                            fontStyle: bundleConfig?.bundles_design?.product_name_style?.split(" ")[1],
                            color: bundleConfig?.bundles_design?.product_name_color,
                        }}
                    >
                        {/* {bundleConfig.quantity_text || "Qty"} : &nbsp; */}
                        <span
                            style={{
                                border: "1px solid #d6d6d6",
                                borderColor: `${bundleConfig?.bundles_design?.product_border_color}`,
                                padding: "2px 5px",
                                borderRadius: "4px",
                                display: "grid",
                                placeItems: "center",
                                color: bundleConfig?.bundles_design?.product_name_color || "#303030",
                                backgroundColor: "transparent",
                            }}
                        >
                            {product.quantity || 0}
                        </span>
                    </div>
                </InspectorEditableBlock>
            )}
        </>
    );

    const renderSubscription = (
        <div style={{ paddingTop: "3px" }}>
            <ProductSubscriptionsPreview
                product={product}
                setSelectedVariants={setSelectedVariants}
                key={product.id}
                bundleConfig={bundleConfig}
            />
        </div>
    );
    const userShopname = standAlone ? window.kefi_bundles.shop : shopify.config.shop;
    const effectiveMetafield = buildMetafieldFromSwatchOptions({
        product,
        bundleConfig,
    });
    const renderVariantSelector = (
        <>
            {product.variants.length > 1 && (
                <div
                    style={{
                        marginTop:
                            bundleConfig?.selected_template_standard !== AvailableStandardTemplates.VERTICAL_CLASSIC
                                ? 10
                                : 0,
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                        width: "100%",
                        zoom:
                            bundleConfig.selected_template_standard == AvailableStandardTemplates.HORIZONTAL_BASIC
                                ? "0.95"
                                : "1",
                    }}
                >
                    {bundleConfig?.show_swatches}
                    {selectedVariants.map((_: any, i: number) =>
                        userShopname === "typsy-beauty.myshopify.com" ? (
                            <Swatches
                                bundlesDesign={bundleConfig?.bundles_design}
                                key={i}
                                variants={product.variants}
                                handleChange={setSelectedVariants}
                                selected={selectedVariants}
                                options={product.options || []}
                                productCardIndex={i}
                                standAlone={standAlone}
                            />
                        ) : bundleConfig?.show_swatches && effectiveMetafield ? (
                            userShopname === COOLGEL_STORE ? (
                                <OldCustomSwatches
                                    key={i}
                                    variants={product.variants}
                                    handleChange={setSelectedVariants}
                                    selected={selectedVariants}
                                    options={product.options || []}
                                    productCardIndex={i}
                                    standAlone={standAlone}
                                    metafield={effectiveMetafield}
                                    bundlesDesign={bundleConfig?.bundles_design}
                                    bundleConfig={bundleConfig}
                                />
                            ) : (
                                <CustomSwatches
                                    key={i}
                                    variants={product.variants}
                                    handleChange={setSelectedVariants}
                                    selected={selectedVariants}
                                    options={product.options || []}
                                    productCardIndex={i}
                                    standAlone={standAlone}
                                    metafield={effectiveMetafield}
                                    bundlesDesign={bundleConfig?.bundles_design}
                                    bundleConfig={bundleConfig}
                                />
                            )
                        ) : userShopname === COOLGEL_STORE ? (
                            <VariantSelector
                                key={i}
                                variants={product.variants}
                                handleChange={setSelectedVariants}
                                selected={selectedVariants}
                                index={index}
                                bundleLevel={bundleConfig.bundle_product_level}
                                bundlesDesign={bundleConfig?.bundles_design}
                                options={product.options || []}
                                setUnavailableSelected={() => {}}
                                productCardIndex={i}
                                formId={bundleConfig.form_id || ""}
                                bundleType={bundleConfig.bundle_type || ""}
                                standAlone={standAlone}
                                realProduct={product}
                                showSerialNumber={false}
                            />
                        ) : (
                            <VariantSelectorV2
                                key={i}
                                variants={product.variants}
                                handleChange={setSelectedVariants}
                                selected={selectedVariants}
                                options={product.options || []}
                                productCardIndex={i}
                                standAlone={standAlone}
                                metafield={effectiveMetafield}
                                bundlesDesign={bundleConfig?.bundles_design}
                                bundleConfig={bundleConfig}
                            />
                        ),
                    )}
                </div>
            )}
        </>
    );

    const renderSubscriptionSelector = (
        <>
            {product.isSubscribed && (
                <div style={{ width: "100%", color: bundleConfig?.bundles_design?.product_name_color }}>
                    <div style={{ margin: "1px 0", fontSize: "8px" }}>
                        <span className={styles.separator}></span>
                    </div>

                    <SubscriptionSelector
                        product={product}
                        selectedVariants={selectedVariants}
                        setSelectedVariants={setSelectedVariants}
                    />
                </div>
            )}
        </>
    );

    const renderSelectedTemplate = () => {
        const isLastCard = index === bundleConfig?.products?.length - 1;

        const productCount = bundleConfig?.products?.length ?? 0;
        const noOfColumnsOnUI = productCount === 4 ? 2 : Math.min(productCount, 3);

        switch (bundleConfig.selected_template_standard) {
            case AvailableStandardTemplates.HORIZONTAL_BASIC:
                return (
                    <div style={{ position: "relative" }}>
                        {index > 0 && index % noOfColumnsOnUI !== 0 && (
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="plusIcon">
                                <div
                                    className={styles.plusSign}
                                    style={{
                                        borderRadius: "4px",
                                        border: "1px solid #d6d6d6",
                                        borderColor: bundleConfig?.bundles_design?.product_border_color,
                                        position: "absolute",
                                        left: "-20px",
                                        top: "50%",
                                    }}
                                >
                                    <PlusIcon color={bundleConfig?.bundles_design?.product_border_color} />
                                </div>
                            </InspectorEditableBlock>
                        )}

                        <InspectorEditableBlock
                            bundleType={bundleConfig?.bundle_type}
                            settingKey="productCard"
                            tagsKey={product.tags?.toString()}
                            productId={getProductId(product.id)}
                        >
                            <div
                                style={{
                                    border: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                    borderRadius: bundleConfig?.bundles_design?.border_radius,
                                    // boxShadow: `0px 2px 9px 0px ${hexToRgba(bundleConfig?.bundles_design?.product_border_color, 0.5)}`,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    gap: "6px",
                                    alignItems: "center",
                                    backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                    lineHeight: "normal",
                                    width: "100%",
                                    height: "100%",
                                }}
                                className={styles.singleProduct}
                            >
                                <div
                                    className={styles.productInfoRight}
                                    style={{
                                        flexDirection: "column",
                                        alignItems: "center",
                                    }}
                                >
                                    <ProductImageWrapper
                                        product={product}
                                        handleProductClick={handleProductClick}
                                        bundleConfig={bundleConfig}
                                        isMobile={isMobile}
                                        selectedVariants={selectedVariants}
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            gap: "8px",
                                            textAlign: "center",
                                            lineHeight: "normal",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {renderTitle}
                                        {renderVariantInformation()}
                                        <div>{renderQuantity}</div>
                                    </div>
                                </div>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        width: "100%",
                                    }}
                                >
                                    {renderPrice}
                                    {renderVariantSelector}
                                </div>

                                {renderSubscriptionSelector}
                            </div>
                        </InspectorEditableBlock>
                    </div>
                );
            case AvailableStandardTemplates.VERTICAL_BASIC:
                return (
                    <>
                        {/* {index > 0 &&
                            bundleConfig.selected_template_standard != AvailableStandardTemplates.HORIZONTAL_BASIC && (
                                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="plusIcon">
                                    <div
                                        className={styles.plusSign}
                                        style={{
                                            borderRadius: "4px",
                                            border: "1px solid #d6d6d6",
                                            borderColor: bundleConfig?.bundles_design?.product_border_color,
                                        }}
                                    >
                                        <PlusIcon color={bundleConfig?.bundles_design?.product_border_color} />
                                    </div>
                                </InspectorEditableBlock>
                            )} */}
                        <InspectorEditableBlock
                            bundleType={bundleConfig?.bundle_type}
                            settingKey="productCard"
                            tagsKey={product.tags?.toString()}
                            productId={getProductId(product.id)}
                        >
                            <div
                                style={{
                                    ...(!isLastCard
                                        ? {
                                              //   borderBottom: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                          }
                                        : {}),
                                    // borderRadius: bundleConfig?.bundles_design?.border_radius,
                                    // boxShadow: `0px 2px 9px 0px ${hexToRgba(bundleConfig?.bundles_design?.product_border_color, 0.5)}`,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                    lineHeight: "normal",
                                }}
                                className={styles.singleProduct}
                            >
                                <div
                                    className={styles.productInfoRight}
                                    style={{
                                        flexDirection:
                                            bundleConfig.selected_template_standard ==
                                            AvailableStandardTemplates.HORIZONTAL_BASIC
                                                ? "column"
                                                : "row",
                                    }}
                                >
                                    <ProductImageWrapper
                                        product={product}
                                        handleProductClick={handleProductClick}
                                        bundleConfig={bundleConfig}
                                        isMobile={isMobile}
                                        selectedVariants={selectedVariants}
                                        overrideQtyVisibility={true}
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: "5px",
                                            width: "100%",
                                            lineHeight: "normal",
                                        }}
                                    >
                                        {renderTitle}

                                        {renderVariantInformation()}
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "space-between",
                                                gap: "5px",
                                                lineHeight: "normal",
                                            }}
                                        >
                                            {renderPrice}
                                            {/* {renderQuantity} */}
                                        </div>
                                    </div>
                                </div>

                                {renderSubscription}
                                {renderVariantSelector}

                                {renderSubscriptionSelector}
                            </div>
                        </InspectorEditableBlock>
                        {!isLastCard && (
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="seperator">
                                <div
                                    className={styles.separator}
                                    style={{
                                        margin: "0 12px",
                                        width: "auto",
                                        height: bundleConfig?.bundles_design?.product_card_seperator_width,
                                        backgroundColor:
                                            bundleConfig?.bundles_design?.product_card_seperator_color || "#e0e0e0",
                                    }}
                                >
                                    &nbsp;
                                </div>
                            </InspectorEditableBlock>
                        )}
                    </>
                );
            case AvailableStandardTemplates.VERTICAL_CLASSIC:
                return (
                    <>
                        {/* {index > 0 &&
                            bundleConfig.selected_template_standard != AvailableStandardTemplates.HORIZONTAL_BASIC && (
                                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="plusIcon">
                                    <div
                                        className={styles.plusSign}
                                        style={{
                                            borderRadius: "4px",
                                            border: "1px solid #d6d6d6",
                                            borderColor: bundleConfig?.bundles_design?.product_border_color,
                                        }}
                                    >
                                        <PlusIcon color={bundleConfig?.bundles_design?.product_border_color} />
                                    </div>
                                </InspectorEditableBlock>
                            )} */}

                        <InspectorEditableBlock
                            bundleType={bundleConfig?.bundle_type}
                            settingKey="productCard"
                            tagsKey={product.tags?.toString()}
                            productId={getProductId(product.id)}
                        >
                            <div
                                style={{
                                    ...(!isLastCard
                                        ? {
                                              //   borderBottom: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                          }
                                        : {}),
                                    // borderRadius: bundleConfig?.bundles_design?.border_radius,
                                    // boxShadow: `0px 2px 9px 0px ${hexToRgba(bundleConfig?.bundles_design?.product_border_color, 0.5)}`,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                    lineHeight: "normal",
                                }}
                                className={styles.singleProduct}
                            >
                                <div
                                    className={styles.productInfoRight}
                                    style={{
                                        flexDirection:
                                            bundleConfig.selected_template_standard ==
                                            AvailableStandardTemplates.HORIZONTAL_BASIC
                                                ? "column"
                                                : "row",
                                    }}
                                >
                                    <ProductImageWrapper
                                        product={product}
                                        handleProductClick={handleProductClick}
                                        bundleConfig={bundleConfig}
                                        isMobile={isMobile}
                                        selectedVariants={selectedVariants}
                                        overrideQtyVisibility={true}
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: isMobile ? "column" : "column",
                                            justifyContent: "space-between",
                                            gap: "5px",
                                            width: "76%",
                                            lineHeight: "normal",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "flex-start",
                                                justifyContent: "space-between",
                                                gap: "6px",
                                                lineHeight: "normal",
                                            }}
                                        >
                                            <div>
                                                {renderTitle}
                                                {renderVariantInformation()}
                                            </div>

                                            {/* {renderQuantity} */}
                                            <div>{renderPrice}</div>
                                        </div>
                                        {renderVariantSelector}
                                        {renderSubscription}
                                    </div>
                                </div>

                                {renderSubscriptionSelector}
                            </div>
                        </InspectorEditableBlock>
                        {!isLastCard && (
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="seperator">
                                <div
                                    className={styles.separator}
                                    style={{
                                        margin: "0 12px",
                                        width: "auto",
                                        height: bundleConfig?.bundles_design?.product_card_seperator_width,
                                        backgroundColor:
                                            bundleConfig?.bundles_design?.product_card_seperator_color || "#e0e0e0",
                                    }}
                                >
                                    &nbsp;
                                </div>
                            </InspectorEditableBlock>
                        )}
                    </>
                );
            default:
                return (
                    <>
                        {/* {index > 0 &&
                            bundleConfig.selected_template_standard != AvailableStandardTemplates.HORIZONTAL_BASIC && (
                                <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="plusIcon">
                                    <div
                                        className={styles.plusSign}
                                        style={{
                                            borderRadius: "4px",
                                            border: "1px solid #d6d6d6",
                                            borderColor: bundleConfig?.bundles_design?.product_border_color,
                                        }}
                                    >
                                        <PlusIcon color={bundleConfig?.bundles_design?.product_border_color} />
                                    </div>
                                </InspectorEditableBlock>
                            )} */}

                        <InspectorEditableBlock
                            bundleType={bundleConfig?.bundle_type}
                            settingKey="productCard"
                            tagsKey={product.tags?.toString()}
                            productId={getProductId(product.id)}
                        >
                            <div
                                style={{
                                    ...(!isLastCard
                                        ? {
                                              //   borderBottom: `${bundleConfig?.bundles_design?.border_width}px solid ${bundleConfig?.bundles_design?.product_border_color}`,
                                          }
                                        : {}),
                                    // borderRadius: bundleConfig?.bundles_design?.border_radius,
                                    // boxShadow: `0px 2px 9px 0px ${hexToRgba(bundleConfig?.bundles_design?.product_border_color, 0.5)}`,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    backgroundColor: bundleConfig?.bundles_design.product_background_color,
                                    lineHeight: "normal",
                                }}
                                className={styles.singleProduct}
                            >
                                <div
                                    className={styles.productInfoRight}
                                    style={{
                                        flexDirection:
                                            bundleConfig.selected_template_standard ==
                                            AvailableStandardTemplates.HORIZONTAL_BASIC
                                                ? "column"
                                                : "row",
                                    }}
                                >
                                    <ProductImageWrapper
                                        product={product}
                                        handleProductClick={handleProductClick}
                                        bundleConfig={bundleConfig}
                                        isMobile={isMobile}
                                        selectedVariants={selectedVariants}
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: isMobile ? "column" : "row",
                                            justifyContent: "space-between",
                                            gap: "5px",
                                            width: "100%",
                                            lineHeight: "normal",
                                        }}
                                        data-sett
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                                gap: "6px",
                                                lineHeight: "normal",
                                            }}
                                        >
                                            {renderTitle}
                                            {renderVariantInformation()}
                                            {renderQuantity}
                                        </div>

                                        {renderSubscription}
                                        <div>{renderPrice}</div>
                                    </div>
                                    {renderVariantSelector}
                                </div>

                                {renderSubscriptionSelector}
                            </div>
                        </InspectorEditableBlock>
                        {!isLastCard && (
                            <InspectorEditableBlock bundleType={bundleConfig?.bundle_type} settingKey="seperator">
                                <div
                                    className={styles.separator}
                                    style={{
                                        margin: "0 12px",
                                        width: "auto",
                                        height: bundleConfig?.bundles_design?.product_card_seperator_width,
                                        backgroundColor:
                                            bundleConfig?.bundles_design?.product_card_seperator_color || "#e0e0e0",
                                    }}
                                >
                                    &nbsp;
                                </div>
                            </InspectorEditableBlock>
                        )}
                    </>
                );
        }
    };

    return renderSelectedTemplate();
};

export const StandardPreview = ({ bundleConfig, standAlone, appConfigContext, targetForm }: Props_StandardPreview) => {
    const [totalPrice, setTotalPrice] = useState(0);
    const [compareAtPrice, setCompareAtPrice] = useState(0);
    const { currency, money_format } = appConfigContext;
    const [trackVariant, setTrackVariant] = useState<any[]>([]);
    const bundleRef = useRef(null);
    const { isMobile } = useIsMobile();

    // console._log("trackVariant", trackVariant);

    const transformedVariants = Array.isArray(trackVariant)
        ? trackVariant
              .map((variants) => {
                  return Array.isArray(variants)
                      ? variants.map((variant: any) => {
                            return variant.id.split("/").pop();
                        })
                      : []; // Return empty array if variants is not an array
              })
              .flat()
        : []; // Return empty array if trackVariant is not an array

    useEffect(() => {
        if (bundleConfig?.products) {
            let totalPrice = 0;
            let compPrice = 0;

            // Loop through all selected variants from each product in trackVariant
            trackVariant.forEach((productVariants) => {
                if (productVariants && productVariants.length) {
                    productVariants.forEach((variant: any) => {
                        if (variant && variant.price) {
                            totalPrice += bundleConfig?.apply_discount_on_compare_price
                                ? +variant?.compareAtPrice
                                : +variant.price; // Add each variant's price to the total
                        }
                        if (variant && variant.compareAtPrice) {
                            compPrice += +variant.compareAtPrice;
                        }
                    });
                }
            });

            // Set the final total price
            setTotalPrice(totalPrice);
            setCompareAtPrice(compPrice);
        }
    }, [
        trackVariant,
        bundleConfig?.products,
        bundleConfig?.discount_type,
        bundleConfig?.discount_value,
        bundleConfig?.apply_discount_on_compare_price,
    ]);

    useEffect(() => {
        const temp: any[] = [];
        bundleConfig?.products?.map((pd) => {
            temp.push(pd.selectedVariants);
        });
        setTrackVariant(temp);
    }, [bundleConfig?.products]);

    const isEverthingAvailable = useMemo(() => {
        return bundleConfig.products.every((p) => {
            return p.variants.some((vv) => vv.availableForSale);
        });
    }, [bundleConfig.products]);

    if (!bundleConfig) return null;

    return (
        <BundlePreviewWrapper
            bundleConfig={{
                ...bundleConfig,
                ...(!isEverthingAvailable && {
                    disableAddToCartButton: true,
                    add_to_cart_cta_text: bundleConfig?.no_stock_text || "Out of stock",
                }),
            }}
            standAlone={standAlone}
            transformedVariants={transformedVariants}
            currency={currency}
            money_format={money_format}
            totalPrice={totalPrice}
            compareAtPriceTotal={bundleConfig?.apply_discount_on_compare_price ? compareAtPrice : totalPrice}
            targetForm={targetForm}
        >
            <>
                <div
                    className={styles.products}
                    ref={bundleRef}
                    style={{
                        display:
                            bundleConfig?.products?.length == 0
                                ? "block"
                                : bundleConfig.selected_template_standard == AvailableStandardTemplates.HORIZONTAL_BASIC
                                  ? "grid"
                                  : "flex",
                        flexDirection:
                            bundleConfig.selected_template_standard == AvailableStandardTemplates.HORIZONTAL_BASIC
                                ? "row"
                                : "column",
                        gridTemplateColumns:
                            bundleConfig.products.length == 1
                                ? "1fr"
                                : bundleConfig.products.length == 2 || bundleConfig.products.length == 4
                                  ? "1fr 1fr"
                                  : "1fr 1fr 1fr",
                        gap:
                            bundleConfig.selected_template_standard == AvailableStandardTemplates.HORIZONTAL_BASIC
                                ? "10px 22px"
                                : "6px",
                        overflowX: "auto",
                        fontSize: bundleConfig?.bundles_design?.bundle_title_size,
                        paddingBottom: "5px",
                        padding: "1px",
                    }}
                >
                    {bundleConfig?.products?.length ? (
                        bundleConfig?.products?.map((product, index) => {
                            return (
                                <ProductCard
                                    key={product?.id + product?.variants[0]?.id}
                                    index={index}
                                    product={product}
                                    bundleConfig={bundleConfig}
                                    appConfigContext={appConfigContext}
                                    standAlone={standAlone || false}
                                    setTrackVariant={setTrackVariant}
                                    isMobile={isMobile}
                                />
                            );
                        })
                    ) : (
                        <ProductCardShimmer />
                    )}
                </div>
                {/* Conditional rendering of the total bar */}
            </>
        </BundlePreviewWrapper>
    );
};

export default StandardBundle;
